import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TyresFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM5.6 11.96C5.6 15.54 8.48 18.38 12 18.38C15.52 18.38 18.4 15.54 18.4 11.96C18.4 8.38 15.52 5.54 12 5.54C8.48 5.54 5.6 8.38 5.6 11.96ZM7.98 11.96C7.98 9.72 9.76 7.9 12 7.9C14.24 7.9 16.02 9.72 16.02 11.96C16.02 14.2 14.24 16.02 12 16.02C9.76 16.02 7.98 14.2 7.98 11.96ZM13.62 11.96C13.62 11.06 12.9 10.32 12 10.32C11.1 10.32 10.38 11.06 10.38 11.96C10.38 12.86 11.1 13.6 12 13.6C12.9 13.6 13.62 12.86 13.62 11.96Z" />
    </SvgIcon>
  );
});
